import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Daum} from './store/content-library-store.dto';
import {IEditContentLibraryForm} from './store/content-library-store.facade';


@Injectable({
    providedIn: 'root'
})

export class ContentLibraryService {

    constructor (private http:HttpClient) {}


    /**
     * Fetch contents
     * @returns response
     */
    fetchContents(p: number | string = '', queryString: string = ''){
        return this.http.get(`content-libraries?page=${p}&q=${queryString}`);
    }


    /**
     * Create content libraray
     * @param formData
     * @returns response
     */
    createContent(formData){
        return this.http.post<Daum>('content-libraries', formData);
    }

    /**
     * Update content
     * @param id
     * @returns response
     */
    contentById(id:string){
        return this.http.get(`content-libraries/${id}`);
    }

    /**
     * Update content
     * @param formData
     * @returns response
     */
    updateContent(formData:IEditContentLibraryForm){
        return this.http.put<Daum>(`content-libraries/${formData?.id}`, formData);
    }

    /**
     * duplicate content library
     * @param formData
     * @returns response
     */
    duplicateContent(formData: { id:number }){
        return this.http.post(`content-libraries/${formData?.id}/duplicate`,{});
    }


    /**
     * Remove content
     * @param id
     * @returns response
     */
    removeContent(id:number){
        return this.http.delete(`content-libraries/${id}`);
    }
}
